import logo from "../assets/images/logo.png"

export default function Navbar() {
    return (
			<div className="fixed top-0 left-0 text-left w-full header bg-gradient-to-r from-violet-700 to-purple-500 py-4 text-white font-bold text-lg shadow-lg z-50">
				<div className="flex items-center ml-4">
					<div className="">
						<img src={logo} alt="" className="w-[50px]" />
					</div>
					<p className="pl-4 text-2xl">Todo App</p>
				</div>
			</div>
		);
}
